import script from "./ProfileCreationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCreationDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCreationDialog.vue?vue&type=style&index=0&id=6e238b3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e238b3d"]])

export default __exports__